import { inject, Injectable } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { IUserDetails } from "@irb/app.model";
import { AppService } from "@irb/app.service";

@Injectable({
  providedIn: "root",
})
export class IrbAuthenticationGuard {
  constructor(private router: Router, private as: AppService) {}
  canActivate() {
    const config: IUserDetails = this.as.getItem("IRB_APP_CONFIG");

    if (window.sessionStorage.getItem("IRB_AUTH_TOKEN") && config) {
      if(config.isAccessDenied) {
        this.router.navigate([""]);
        return false;
      } else {
        return true;
      }
    }
    
    this.router.navigate([""]);
    return false;
  }
}

export const irbAuthenticationGuard: CanActivateFn = () => inject(IrbAuthenticationGuard).canActivate();
